"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var HabitatPlus_exports = {};
__export(HabitatPlus_exports, {
  default: () => HabitatPlus_default
});
module.exports = __toCommonJS(HabitatPlus_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.0078 3.16016C11.0078 3.02995 10.9557 2.91927 10.8516 2.82812C10.7604 2.72396 10.6432 2.67188 10.5 2.67188C10.3568 2.67188 10.2331 2.72396 10.1289 2.82812C10.0378 2.91927 9.99219 3.02995 9.99219 3.16016V9.74219H3.41016C3.27995 9.74219 3.16276 9.79427 3.05859 9.89844C2.96745 9.98958 2.92188 10.1068 2.92188 10.25C2.92188 10.3932 2.96745 10.5169 3.05859 10.6211C3.16276 10.7122 3.27995 10.7578 3.41016 10.7578H9.99219V17.3398C9.99219 17.4701 10.0378 17.5872 10.1289 17.6914C10.2331 17.7826 10.3568 17.8281 10.5 17.8281C10.6432 17.8281 10.7604 17.7826 10.8516 17.6914C10.9557 17.5872 11.0078 17.4701 11.0078 17.3398V10.7578H17.5898C17.7201 10.7578 17.8307 10.7122 17.9219 10.6211C18.026 10.5169 18.0781 10.3932 18.0781 10.25C18.0781 10.1068 18.026 9.98958 17.9219 9.89844C17.8307 9.79427 17.7201 9.74219 17.5898 9.74219H11.0078V3.16016Z",
      fill: "currentColor"
    }
  )
);
const SvgHabitatPlus = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var HabitatPlus_default = SvgHabitatPlus;
